const momentLocaleRemap = (locale: string) => {
  if (locale === 'zh-Hant') return 'zh-hk';
  if (locale === 'zh-Hans') return 'zh-cn';
  return locale;
};

export default momentLocaleRemap;
